import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry only in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
    tracePropagationTargets: ["localhost", /^https:\/\/docurapid\.ro/],
    
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of normal sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    
    // Filter out common browser extension errors
    ignoreErrors: [
      // Browser extensions
      "top.GLOBALS",
      "chrome-extension://",
      "moz-extension://",
      // Network errors that are not actionable
      "NetworkError",
      "Failed to fetch",
    ],
    
    beforeSend(event, hint) {
      // Filter sensitive data from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.filter(breadcrumb => {
          // Remove breadcrumbs with sensitive URLs
          if (breadcrumb.data?.url && 
              (breadcrumb.data.url.includes('token=') || 
               breadcrumb.data.url.includes('password='))) {
            return false;
          }
          return true;
        });
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary 
    fallback={({ error, resetError }) => (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="max-w-md w-full bg-card border border-border rounded-lg p-6 text-center">
          <div className="mb-4">
            <svg
              className="mx-auto h-12 w-12 text-destructive"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-foreground mb-2">
            Oops! Ceva nu a mers bine
          </h2>
          <p className="text-muted-foreground mb-4">
            A apărut o eroare neașteptată. Echipa noastră a fost notificată automat.
          </p>
          <div className="flex flex-col gap-2">
            <button
              onClick={resetError}
              className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition"
            >
              Încearcă din nou
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="w-full px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition"
            >
              Înapoi la pagina principală
            </button>
            <button
              onClick={() => {
                const eventId = Sentry.lastEventId();
                if (eventId) {
                  Sentry.showReportDialog({ eventId });
                }
              }}
              className="w-full px-4 py-2 text-sm text-muted-foreground hover:text-foreground transition"
            >
              Raportează problema
            </button>
          </div>
        </div>
      </div>
    )}
    showDialog
  >
    <App />
  </Sentry.ErrorBoundary>
);
